module.exports = __webpack_public_path__ + "media/images/responsive/flow/sola_visit_step_04-5317c42391b01f800d2b5858dfd73999.jpg";